type SubmissionValue = string | File;
type SubmissionEntry = [string, SubmissionValue];

export interface FormSubmission {
    begin: (data: FormData) => string | null;
    finish: () => void;
    reset: () => boolean;
}

const createToken = (): string => {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
};

/**
 * One session is shared by every button in a form. Unchanged data keeps its token,
 * including after a lost response or a successful submit followed by another click.
 * Editing the payload or explicitly resetting the form starts a new submission.
 */
export const createFormSubmission = (): FormSubmission => {
    let pending = false;
    let token: string | null = null;
    let previous: SubmissionEntry[] = [];

    return {
        begin(data) {
            if (pending) return null;

            const entries: SubmissionEntry[] = [];
            data.forEach((value, key) => {
                if (key !== "re_token" && key !== "submission_token") entries.push([key, value]);
            });
            const unchanged = entries.length === previous.length
                && entries.every(([key, value], index) =>
                    key === previous[index][0] && value === previous[index][1]);

            if (!token || !unchanged) {
                token = createToken();
                previous = entries;
            }

            pending = true;
            return token;
        },
        finish() {
            pending = false;
        },
        reset() {
            if (pending) return false;
            token = null;
            previous = [];
            return true;
        }
    };
};
